import { cn } from '@shadcn/lib/utils';

import { Indicator } from '../../../../../components/atoms/indicator/indicator';
import { useIndicator } from '../../../context/indicators';

const WithIndicator = ({
  respondentType,
  children,
  displayIndicator = false,
  className,
  indicatorClassName,
}: {
  readonly respondentType: string;
  readonly children: React.ReactNode;
  readonly displayIndicator?: boolean;
  readonly className?: string;
  readonly indicatorClassName?: string;
}) => {
  const indicator = useIndicator(respondentType);

  if (!displayIndicator || !indicator) return children;
  return (
    <div className={cn(className, 'flex flex-row')}>
      <div>
        <Indicator appearance={indicator.indicatorAppearance} className={cn(indicatorClassName, 'mr-2')}>
          {indicator.shortLabel}
        </Indicator>
      </div>
      <div className="flex-1">{children}</div>
    </div>
  );
};
export { WithIndicator };
